import React, { useEffect, useState } from 'react';
import KeycloakService from '../../../services/KeycloakService';
import { getHRLeavesRequests } from '../../../hr/services/LeaveService';
import { useDispatch, useSelector } from 'react-redux';
import { SHOW_NOTIFICATION, WFHAttribute } from '../../../constants';
import { getUserData } from '../../../services/UserService';
import GenericLoader from '../../../components/Loader/GenericLoader';
import { setFilterDataState } from '../../../modules/filter/filterAction';
import CalenderViewComponent from '../CalenderView/CalenderViewComponent';

function EmployeeLeaveSummaryComponent(props) {
  const dispatch = useDispatch();

  const state = useSelector((state) => state.filterState);

  const [leaveList, setLeaveList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [showError, setShowError] = useState(false);
  const currentUserId = KeycloakService.getUserDetail();
  const [flagResetFilter, setFlagResetFilterData] = useState(false);

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const empName = async (request, id) => {
    const userData = await getUserData(id);
    request.empName = `${userData.data.firstName} ${
      userData.data?.lastName || ''
    }`;
    request.photo = userData.photo;
  };

  const getLeaveList = async () => {
    const leavesRequests = await getHRLeavesRequests(currentUserId, state);
    if (leavesRequests?.isError === false) {
      await Promise.all(
        leavesRequests.data.data.content.map(async (request) => {
          await empName(request, request.employeeId);
        }),
      );
      setLeaveList(leavesRequests.data.data.content);
      setLoader(false);
    }
    if (leavesRequests.status !== 200) {
      dipatchNotification(leavesRequests.type, leavesRequests.message);
    }
  };

  const formatDateToYYYYMMDD = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const resetFilter = () => {
    const date = new Date();
    dispatch(
      setFilterDataState({
        startDate: formatDateToYYYYMMDD(date),
        endDate: formatDateToYYYYMMDD(date),
        status: 'APPROVED',
      }),
    );
    setFlagResetFilterData(true);
  };

  useEffect(() => {
    resetFilter();
    setFlagResetFilterData(true);
  }, []);

  useEffect(() => {
    if (flagResetFilter) {
      getLeaveList();
    }
  }, [state, flagResetFilter]);

  return (
    <>
      {loader ? (
        <div style={{ height: '80vh', overflow: 'hidden' }}>
          <GenericLoader
            rectAttributes={WFHAttribute}
            showError={showError}
            setShowError={setShowError}
          />
        </div>
      ) : (
        <CalenderViewComponent type={'leave'} data={leaveList} />
      )}
    </>
  );
}

export default EmployeeLeaveSummaryComponent;
